<template>
  <div class="login-page">
    <div class="page-wrap">
      <div class="page-wrap-content">
        <div class="page-info">
          <input
            v-model.trim="phoneNum"
            placeholder="请输入手机号码"
            type="text"
            class="info-phone"
          />
          <div class="info-code">
            <input
              v-model.trim="code"
              placeholder="请输入验证码"
              type="text"
            />
            <button :disabled="disbtn" @click="sendAuthCode">
              {{ codeTxt }} {{ time }}
            </button>
          </div>
          <button class="nowBtn" @click="showConfirm">
            立&nbsp;即&nbsp;查&nbsp;询
          </button>
          <div class="state">
            *本权益兑换/领取服务由运营商或运营商的委托方提供
          </div>
          <div class="customer">
            客服热线：<span @click="confirmCall('4007750881')"> 400-775-0881 </span>
          </div>
        </div>
        <div class="tip">
          <div class="radiuTip"></div>
          <div class="tipText customer">
            权益兑换说明：<br />
            1、用户输入订购权益手机号码，验证码；进入登录查询领取会员权益资格；<br />
            2、登录后，确认兑换权益，将会在1个小时内发放到对应领取APP手机账户内，请耐心等候；<br />
            3、如超过12小时内未收到对应权益生效，请拨打客服热线：<span @click="confirmCall('4007750881')"> 400-7750-881 </span>（接听时间：9:30-12:30，14:00-18:00），欢迎来电垂询！
          </div>
        </div>
      </div>
    </div>
    <van-toast id="vanToast" />
    <van-dialog id="vanDialog" />
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'

export default {
  name: 'LoginPage',
  data () {
    return {
      phoneNum: '',
      codeTxt: '验证码',
      time: '',
      disbtn: false,
      code: '',
      limit: false,
      limitText: ''
    }
  },
  methods: {
    validatePhone () {
      if (!this.phoneNum) {
        Toast('请输入手机号码')
        return false
      }
      if (!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.phoneNum)) {
        Toast('请输入正确的手机号码')
        return false
      }
      return true
    },
    handleLimitExceeded (resetCode = false) {
      Dialog.alert({
        title: '提示',
        message: this.limitText,
        messageAlign: 'left'
      }).then(() => {
        this.phoneNum = ''
        if (resetCode) {
          this.codeTxt = '验证码'
          this.code = ''
        }
      })
    },
    showConfirm () {
      if (this.limit === true) {
        this.handleLimitExceeded(true)
        return
      }
      if (!this.validatePhone()) {
        return
      }
      if (!this.code) {
        Toast('请输入验证码')
        return
      }
      this.codeLogin()
      window.sessionStorage.setItem('DGphone', JSON.stringify(this.phoneNum))
    },
    sendAuthCode () {
      const that = this
      if (this.limit === true) {
        this.handleLimitExceeded(false)
        return
      }
      if (!this.validatePhone()) {
        return
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      this.$http.post('/member/login/sendAuthCode', {
        mobile: this.phoneNum,
        channel: 'junpinclub'
      }).then((data) => {
        if (data && data.message) {
          Toast.clear()
          Toast(data.message)
          that.sendCode()
        }
      }).catch(() => {
        Toast('发送失败，请稍后重试')
      })
    },
    sendCode () {
      let that = this
      this.disbtn = true
      this.codeTxt = '重新发送'
      this.time = '59'
      this.countDown(
        that.time,
        tick => {
          that.time = tick
        },
        () => {
          that.time = ''
          that.disbtn = false
        }
      )
    },
    countDown (time, tickFunc, done) {
      let tick = () => {
        clearTimeout(this.timeId)
        setTimeout(() => {
          if (time > 0) {
            time--
            tickFunc(time)
            tick()
          } else {
            done()
            return
          }
        }, 1000)
      }
      tick()
    },
    codeLogin () {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      let params = {
        code: this.code,
        phone: this.phoneNum
      }
      this.$http.post('/mobile/checkCode', params).then((data) => {
        if (data === 0 || data.code === 0) {
          Toast.clear()
          let page = '/coupon/integration/show_package'
          if (this.getUrlParam('backUrl')) {
            page = decodeURIComponent(this.getUrlParam('backUrl'))
          }
          this.$router.push(page)
        } else {
          Toast(data.message || data)
        }
      }).catch((data) => {
        if (data && data.message) {
          Toast(data.message)
        }
      })
    },
    getUrlParam (name, newUrl) {
      let l = newUrl || window.location.href
      let i = l.indexOf('?')
      if (i < 0) return null
      let str = l.slice(i)
      if (!str) return null
      let arr = str.match(/([^?&=#]+)=([^?&=#/]*)/g)
      if (Object.prototype.toString.call(arr).slice(8, -1) !== 'Array') return null
      let obj = {}
      arr.forEach(v => {
        let temp = v.split('=')
        if (temp.length > 1) {
          obj[temp[0]] = temp[1]
        }
      })
      if (name) return obj[name]
      return obj
    },
    confirmCall (phone) {
      if (navigator.userAgent.toLowerCase().indexOf('android') > -1 || navigator.userAgent.toLowerCase().indexOf('adr') > -1) {
        this.copyText(phone)
      } else {
        var link = document.createElement('a')
        link.href = 'tel:' + phone
        document.body.appendChild(link)
        link.click()
        setTimeout(function () {
          document.body.removeChild(link)
        }, 3000)
      }
    },
    copyText (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      Toast('复制成功')
    }
  },
  created () {
    document.title = '特惠权益领取'
  }
}
</script>

<style lang="less" scoped>
.login-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #33323e;
}

.pageWrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.page-wrap-content {
  flex: 1;
  width: 100%;
  background-image: url('https://static.jetmobo.com/image/content-h5/20230424/1682325290222.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 4rem;
  box-sizing: border-box;
  overflow: hidden;
}

.page-info {
  width: 85%;
  max-width: 12.88rem;
  background-image: url('https://static.jetmobo.com/image/content-h5/20230424/1682325297919.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 1.2rem 0.6rem 0.8rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.info-phone {
  width: 100%;
  height: 0.9rem;
  background: #FAF4E9;
  border: 0.04rem solid #DDA265;
  border-radius: 0.16rem;
  margin-bottom: 0.4rem;
  text-indent: 0.4rem;
  font-size: 14px;
  box-sizing: border-box;
}

.info-phone::placeholder {
  color: #c7c7c7;
}

.info-code {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 0.6rem;
  font-size: 14px;
  box-sizing: border-box;
}

.info-code input {
  flex: 1;
  height: 0.9rem;
  background: #FAF4E9;
  border-radius: 0.16rem;
  border: 0.04rem solid #DDA265;
  margin-right: 0.4rem;
  text-indent: 0.4rem;
  box-sizing: border-box;
}

.info-code input::placeholder {
  color: #C7C7C7;
}

.info-code button {
  width: 2.4rem;
  height: 0.9rem;
  background: #F6DAAA;
  border: 0.04rem solid #DDA265;
  border-radius: 0.16rem;
  outline: none;
  color: #333;
  font-size: 0.38rem;
  white-space: nowrap;
}

.info-code button:disabled {
  background: #e0e0e0;
  color: #999;
}

.nowBtn {
  width: 100%;
  height: 1rem;
  background: linear-gradient(0deg, #EACC97 0%, #DDA265 100%);
  border-radius: 0.16rem;
  border: none;
  font-size: 0.48rem;
  color: #FFFFFF;
}

.nowBtn:active {
  opacity: 0.8;
}

.state {
  padding: 0.2rem 0 0 0;
  font-size: 0.18rem;
  color: #C7C7C7;
  text-align: center;
}

.customer {
  padding-top: 0.3rem;
  font-size: 12px;
  color: #B8B8B8;
}

.customer.tipText {
  text-align: left;
}

.customer span {
  color: #C49352;
  font-size: 12px;
  font-weight: bold;
}

.tip {
  width: 85%;
  max-width: 12.88rem;
  color: #fff;
  margin-top: 0.3rem;
  display: flex;
  font-size: 12px;
  line-height: 1.5;
  text-align: left;
}

.tip .radiuTip {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #dfab6f;
  margin: 4px 4px 0 0;
  flex-shrink: 0;
}

.tipText {
  flex: 1;
  text-align: left;
}

@media screen and (min-width: 320px) {
  html {
    font-size: 21.33px !important;
  }
}

@media screen and (min-width: 360px) {
  html {
    font-size: 24px !important;
  }
}

@media screen and (min-width: 375px) {
  html {
    font-size: 25px !important;
  }
}

@media screen and (min-width: 390px) {
  html {
    font-size: 26px !important;
  }
}

@media screen and (min-width: 400px) {
  html {
    font-size: 26.7px !important;
  }
}

@media screen and (min-width: 411px) {
  html {
    font-size: 27.4px !important;
  }
}
</style>
